import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GasSelectComponent } from './wrapper/gas-select.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasSelectDropdownComponent } from './dropdown/gas-select-dropdown.component';
import { GasDividerModule } from '../../layout/gas-divider/gas-divider.module';
import { GasSelectOptionComponent } from './option/gas-select-option.component';
import { GasCheckboxModule } from '../gas-checkbox/gas-checkbox.module';
import { GasClickOutsideDirectiveModule } from '../../utils/click-outside-directive/gas-click-outside.module';
import { GasScrollModule } from '../../utils/gas-scroll/gas-scroll.module';
import { GasButtonModule } from '../gas-button/gas-button.module';
import { GasInputModule } from '../gas-input/gas-input.module';
import { GasObjectFilterModule } from '../../utils/gas-object-filter-pipe/gas-object.filter.module';
import { GasBadgeModule } from '../../layout/gas-badge/gas-badge.module';
import { GasSelectDropdownDirective } from './dropdown/gas-select-dropdown.directive';
import { GasSpinnerModule } from '../../common/gas-spinner/gas-spinner.module';

const COMPONENTS = [
  GasSelectComponent,
  GasSelectDropdownComponent,
  GasSelectOptionComponent,
];

const DIRECTIVES = [
  GasSelectDropdownDirective,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GasIconsModule,
    GasDividerModule,
    GasCheckboxModule,
    GasScrollModule,
    GasButtonModule,
    GasInputModule,
    GasClickOutsideDirectiveModule,
    GasObjectFilterModule,
    GasBadgeModule,
    GasSpinnerModule,
  ],
  declarations: [
    COMPONENTS,
    DIRECTIVES,
  ],
  exports: [
    COMPONENTS,
    DIRECTIVES,
  ],
  entryComponents: [
    GasSelectDropdownComponent,
  ],
})
export class GasSelectModule { }
